var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6089 4.05333L11.9467 0.391111C11.6956 0.14 11.3578 0 11.0044 0H4.99778C4.64444 0 4.30444 0.14 4.05556 0.391111L0.391111 4.05333C0.14 4.30444 0 4.64222 0 4.99556V11.0022C0 11.3556 0.14 11.6956 0.391111 11.9444L4.05556 15.6067C4.30667 15.8578 4.64444 15.9978 4.99778 15.9978H11.0044C11.3578 15.9978 11.6978 15.8578 11.9467 15.6067L15.6111 11.9444C15.8622 11.6933 16.0022 11.3556 16.0022 11.0022V4.99556C16.0022 4.64222 15.8622 4.30222 15.6111 4.05333H15.6089ZM10.6933 9.75111C10.9533 10.0111 10.9533 10.4333 10.6933 10.6933C10.5622 10.8244 10.3933 10.8889 10.2222 10.8889C10.0511 10.8889 9.88 10.8244 9.75111 10.6933L8 8.94222L6.24889 10.6933C6.11778 10.8244 5.94889 10.8889 5.77778 10.8889C5.60667 10.8889 5.43555 10.8244 5.30667 10.6933C5.04667 10.4333 5.04667 10.0111 5.30667 9.75111L7.05778 8L5.30667 6.24889C5.04667 5.98889 5.04667 5.56667 5.30667 5.30667C5.56667 5.04667 5.98889 5.04667 6.24889 5.30667L8 7.05778L9.75111 5.30667C10.0111 5.04667 10.4333 5.04667 10.6933 5.30667C10.9533 5.56667 10.9533 5.98889 10.6933 6.24889L8.94222 8L10.6933 9.75111Z",
    fill: "#F5474B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCard);
export default __webpack_public_path__ + "static/media/close-card.ee96125d1fda6c399822cdcd69e96277.svg";
export { ForwardRef as ReactComponent };